<div [ngClass]="{'pointer-events-none opacity-0' : !open }" class="relative z-50 transition-opacity duration-500 " aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
  <!-- Background backdrop, show/hide based on slide-over state. -->
  <div  class="fixed inset-0 transition-opacity opacity-0 ease-in-out duration-500 bg-black bg-opacity-60" [ngClass]="{'opacity-100': open}"></div>

  <div  class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">

      
<div *ngIf="!editMode" class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-16">
  <div class="pointer-events-auto overflow-scroll w-screen max-w-6xl transform transition ease-in-out duration-500 sm:duration-700 " [ngClass]="{'translate-x-full' : !open, 'translate-x-0': open}">
            <div *ngIf="appointment && appointment.id" class="min-h-full relative  bg-gray-100 py-6 shadow-xl">
             
              <ubc-appointment-summary *ngIf="appointment && appointment.id" [appointment]="appointment" (editModeRequested)="editMode = true"></ubc-appointment-summary> 


<div *ngIf="appointment  && appointment.customer" class="absolute top-0 left-0 w-full px-8 py-4 bg-black text-white text-xl z-50">
  <div>{{ appointment.customer.getFullName()}}</div>
  
  <div class="absolute right-4 top-1/2 transform  -translate-y-1/2">
    <button type="button" (click)="closeClicked()" (touchstart)="closeTouched($event)" class="close-btn  rounded-md text-white hover:text-black hover:bg-white focus:outline-none focus:ring-2 focus:ring-accent-light focus:ring-offset-2 z-50">
      <span class="absolute -inset-2.5"></span>
      <span class="sr-only">Close panel</span>
      <svg class="h-6 w-6 " fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
    
    </div>

                
              </div>

                
            </div>
            </div>

            

        </div>

        
   

      <div *ngIf="editMode" class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-0 sm:pl-16">
        <!--
          Slide-over panel, show/hide based on slide-over state.

          Entering: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-full"
            To: "translate-x-0"
          Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-0"
            To: "translate-x-full"
        -->
        <div class="pointer-events-auto w-screen max-w-6xl transform transition ease-in-out duration-500 sm:duration-700 " [ngClass]="{'translate-x-full' : !open, 'translate-x-0': open}">
          <div class="flex h-full flex-col overflow-y-scroll bg-gray-100 py-6 shadow-xl">
            <div class="px-4 sm:px-6">
              <div class="flex items-start justify-between">
                <h2  class="text-base font-semibold leading-6 text-gray-900" id="slide-over-title">
                  {{ (appointment && appointment.id) ? "Update": "New" }} Appointment
                </h2>
                <div class="ml-3 flex h-7 items-center">
                  <button type="button" (click)="closeClicked()" (touchstart)="closeTouched($event)" class="close-btn relative rounded-md text-accent hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-accent-light focus:ring-offset-2">
                    <span class="absolute -inset-2.5"></span>
                    <span class="sr-only">Close panel</span>
                    <svg class="h-6 w-6 " fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="relative mt-6 flex-1 px-4 sm:px-6" *ngIf="appointment">
              

<div class="space-y-10 divide-y divide-gray-900/10 bg-gray-100">

  <div *ngIf="appointment && appointment.id && appointment.status === 'CONFIRMED'" class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
    <div class="px-4 sm:px-0">
      <h2 class="text-base font-semibold leading-7 text-gray-900">Appointment Success</h2>
      <p class="mt-1 text-sm leading-6 text-gray-600">Appointments rated 3+ stars will automatically be asked for online reviews.</p>
      
    </div>

    <div class="col-span-2">
        <ubc-appointment-rating [appointment]="appointment"></ubc-appointment-rating>
        
    </div>
    
  </div>

  <div *ngIf="appointment && appointment.id && appointment.status !== 'CONFIRMED'" class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
    <div class="px-4 sm:px-0 pt-10">
      <h2 class="text-base font-semibold leading-7 text-gray-900"></h2>
      <p class="mt-1 text-sm leading-6 text-gray-600"></p>
    </div>

    <div class="col-span-2 pt-10">

      <button (click)="confirmAppointmentClicked()" type="button" class="rounded-md bg-accent px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-accent-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">CONFIRM APPOINTMENT</button>
      <p class="text-xs my-4">If the cutsomer has paid their deposit, or does not need to pay a deposit the appointment can be confirmed</p>
    </div>
    
  </div>

  

  <div class="grid grid-cols-1 gap-x-8 gap-y-8 md:grid-cols-3">
    <div class="px-4 sm:px-0 pt-10">
      <h2 class="text-base font-semibold leading-7 text-gray-900">Customer</h2>
      <p class="mt-1 text-sm leading-6 text-gray-600">This is the information you store for the customer, and is used for all of the customers appointments.</p>
    </div>

    <div class="col-span-2 pt-10">
        <ubc-customer-edit-form *ngIf="appointment && appointment.customer" [customer]="appointment.customer" (cleared)="customerSelectionCleared()"></ubc-customer-edit-form>
        <div  *ngIf="appointment && !appointment.customer" class="">
          <ubc-customer-search (customerWasPicked)="customerPickedFromSearch($event)"></ubc-customer-search>
        </div>
    </div>
    
  </div>

 

  <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3">
    <div class="px-4 sm:px-0">
      <h2 class="text-base font-semibold leading-7 text-gray-900">Appointment Details</h2>
      <p class="mt-1 text-sm leading-6 text-gray-600">This is the information related specifically to this appointment.</p>
    </div>

    <form [formGroup]="appointmentForm" (ngSubmit)="appointmentFormSubmit()" class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
      <div class="px-4 py-6 sm:p-8">
        <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

          <div class="sm:col-span-6">
            <legend class="text-sm font-medium text-gray-900">Date / Time</legend>
            <div class="grid grid-cols-3">
              <div class="col-span-3 sm:col-span-1 flex flex-col justify-center">
                <mat-form-field>
                  <mat-label>Appointment Date</mat-label>
                  <input formControlName="startTime" matInput [matDatepicker]="picker" (dateChange)="onDateChange($event)">
                  
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-span-3 sm:col-span-2">
                <div class="grid grid-cols-6">
                  <div class="col-span-1 py-2 pr-2 text-xs font-bold uppercase flex flex-col justify-center text-right">Start</div>
                  <div class="col-span-5 py-2">
                    <div class="ngx-timepicker-field-example">
                      
                      <ngx-timepicker-field [(ngModel)]="pickedStartTime" [minutesGap]="5" [ngModelOptions]="{standalone: true}" (ngModelChange)="onTimeChange($event, 'start')"></ngx-timepicker-field>
                    </div>
                  </div>

                  <div class="col-span-1 py-2 pr-2 text-xs font-bold uppercase flex flex-col justify-center text-right">End</div>
                  <div class="col-span-5 py-2">
                    <div class="ngx-timepicker-field-example">
                      <ngx-timepicker-field [(ngModel)]="pickedEndTime" [minutesGap]="5" [ngModelOptions]="{standalone: true}" (ngModelChange)="onTimeChange($event, 'end')"></ngx-timepicker-field>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
          
          <div class="sm:col-span-6">
            <fieldset>
              <legend class="text-sm font-medium text-gray-900">Horse</legend>

              <ng-container *ngIf="!appointment.customer">
                <ubc-no-customer-message target="horse"></ubc-no-customer-message>
              </ng-container>
             
              <ng-container *ngIf="appointment.customer">
                <input type="hidden" formControlName="horseId" />
                <ubc-horse-select-create (horseSelected)="horseSelected($event)" [appointment]="appointment"></ubc-horse-select-create>
              </ng-container>
             
              
            </fieldset>
          </div>

          <div class="sm:col-span-6">
            <fieldset >
              <div class="flex items-center justify-between">
                <div class="text-sm font-medium leading-6 text-gray-900">Rider</div>
                
              </div>
              
              <ubc-model-search [model]="'rider'" [customer]="appointment.customer" (modelWasPicked)="riderPickedFromSearch($event)"></ubc-model-search>
              
              <div *ngIf="appointment.riderId" class="grid grid-cols-12 gap-3 mt-3">
                
                <div *ngIf="appointment.riderId && appointment.rider" class="col-span-12 py-3">
                  <label  class="block text-sm font-medium leading-6 text-gray-900">Rider</label>
                  <div class="">{{ appointment.rider.name }}<span (click)="deselectRider()" class="text-xs ml-3 hover:text-red-500 cursor-pointer">change</span></div>
                </div>

                
                <div class="col-span-12 sm:col-span-6">
                  <label for="weight" class="block text-sm font-medium leading-6 text-gray-900">Rider Weight (Kg)</label>
                    <div class="relative mt-2 rounded-md shadow-sm">
                      
                      <input type="number" [(ngModel)]="appointment.riderWeightKg" formControlName="riderWeightKg" class="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6" placeholder="0">
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        <span class="text-gray-500 sm:text-sm" id="price-currency">Kg</span>
                      </div>
                    </div>
                </div>

                <div class="col-span-12 sm:col-span-6">
                  <label for="weight" class="block text-sm font-medium leading-6 text-gray-900">Rider Height (cm)</label>
                    <div class="relative mt-2 rounded-md shadow-sm">
                      
                      <input type="number" [(ngModel)]="appointment.riderHeightCm"  formControlName="riderHeightCm" class="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6" placeholder="0">
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                        <span class="text-gray-500 sm:text-sm" id="price-currency">cm</span>
                      </div>
                    </div>
                </div>
              </div>


            </fieldset>
          </div>
          
          <div class="sm:col-span-6">
            
            <fieldset>
              <legend class="text-sm font-medium text-gray-900">Appointment Address</legend>

              
              <ng-container *ngIf="!appointment.customer">
                <ubc-no-customer-message target="address"></ubc-no-customer-message>
              </ng-container>
             
              <ng-container *ngIf="appointment.customer">
                <input type="hidden" formControlName="addressId" />
                <ubc-address-select-create (addressSelected)="addressSelected($event)" [appointment]="appointment"></ubc-address-select-create>
              </ng-container>

            
            </fieldset>

          </div>

          <div class="sm:col-span-6">
            <fieldset >
              <input type="hidden" formControlName="typeId" />
              <legend class="text-sm font-medium text-gray-900">Appointment Type</legend>
              <div class="space-y-4 mt-4">
                
                <label (click)="appoinmentTypeClicked(type)" *ngFor="let type of appointmentTypes" [ngClass]="{'border-accent ring-2 ring-accent' : isSelectedObject('type', type.id), 'border-gray-300': !isSelectedObject('type', type.id)}" class="relative block cursor-pointer rounded-lg border bg-white px-6 py-4 shadow-sm focus:outline-none sm:flex sm:justify-between">
                  <input type="radio" name="server-size" value="Hobby" class="sr-only">
                  <span class="flex items-center">
                    <span class="flex flex-col text-sm">
                      <span class="font-medium text-gray-900">{{type.name}}</span>
                      <span class="text-gray-500">
                        <span class="block sm:inline">{{type.description}}</span>
                        <span class="hidden sm:mx-1 sm:inline" aria-hidden="true">&middot;</span>
                        <span class="block sm:inline">{{type.duration}} hrs</span>
                      </span>
                    </span>
                  </span>
                  <span class="mt-2 flex text-sm sm:ml-4 sm:mt-0 sm:flex-col sm:text-right">
                    <span class="font-medium text-gray-900">£{{type.defaultCost}}</span>
                    <span class="ml-1 text-gray-500 sm:ml-0"></span>
                  </span>
                 
                  <span [ngClass]="{'border-accent' : isSelectedObject('type', type.id), 'border-transparent': !isSelectedObject('type', type.id)}" class="pointer-events-none absolute -inset-px rounded-lg border-2" aria-hidden="true"></span>
                </label>
               
                
              </div>
            </fieldset>
            
          </div>

          <div class="sm:col-span-6">
            <fieldset >
              <div class="flex items-center justify-between">
                <div class="text-sm font-medium leading-6 text-gray-900">Fitter</div>
                
              </div>
              <input type="hidden" formControlName="fitterId" />
              <div class="mt-2 grid grid-cols-3 gap-3 sm:grid-cols-6">
               
                <label (click)="fitterClicked(fitter)" *ngFor="let fitter of fitters" [ngClass]="{'bg-accent text-white hover:bg-accent-lighter' : isSelectedObject('fitter', fitter.id), 'ring-1 ring-inset ring-gray-300 bg-white text-gray-900 hover:bg-gray-50': !isSelectedObject('fitter', fitter.id)}" class="flex cursor-pointer items-center justify-center rounded-md px-3 py-3 text-sm font-semibold uppercase focus:outline-none sm:flex-1">
                  <input type="radio" name="fitter" value="{{fitter.id}}" class="sr-only">
                  <span>{{ fitter.name }}</span>
                </label>
                
              </div>
            </fieldset>
          </div>

          <div class="sm:col-span-6">
            <fieldset >
              <div class="flex items-center justify-between">
                <div class="text-sm font-medium leading-6 text-gray-900">Saddle Type</div>
                
              </div>
              <input type="hidden" formControlName="saddleTypeId" />
              <div class="mt-2 grid grid-cols-3 gap-3 sm:grid-cols-3">
               
                
                <div (click)="saddleTypeClicked(saddleType, $event)" *ngFor="let saddleType of saddleTypes" [ngClass]="{'bg-accent text-white hover:bg-accent-lighter' : isSelectedObject('saddleType', saddleType.id), 'ring-1 ring-inset ring-gray-300 bg-white text-gray-900 hover:bg-gray-50': !isSelectedObject('saddleType', saddleType.id)}" class="flex cursor-pointer items-center justify-center rounded-md px-3 py-3 text-sm font-semibold uppercase focus:outline-none sm:flex-1">
                  <input type="radio" name="saddleType" value="{{saddleType.id}}" class="sr-only">
                  <span>{{ saddleType.name }}</span>
                </div>
              
                
              </div>
            </fieldset>
          </div>

          <div class="sm:col-span-6">
            <label for="budget" class="block text-sm font-medium leading-6 text-gray-900">New Saddle Budget</label>
              <div class="relative mt-2 rounded-md shadow-sm">
                <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                  <span class="text-gray-500 sm:text-sm">£</span>
                </div>
                <input type="number" formControlName="budget" class="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6" placeholder="0.00" aria-describedby="price-currency">
                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                  <span class="text-gray-500 sm:text-sm" id="price-currency">GBP</span>
                </div>
              </div>
          </div>

          <div class="sm:col-span-6">
            <div>
              <legend class="text-sm font-medium text-gray-900">Notes</legend>
              <div class="mt-2">
                <textarea rows="4" formControlName="notes" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-accent sm:text-sm sm:leading-6"></textarea>
              </div>
            </div>
          </div>

          
 
        </div>
      </div>
      <div class="flex items-center justify-between gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
        <div class="">
          <button *ngIf="appointment.id" type="button" (click)="deleteClicked()" class="rounded-md px-3 py-2 text-sm font-semibold text-red-500 shadow-sm bg-transparent ring-red-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">Delete</button>
        </div>

        <div class="flex space-x-3">
          
          <select formControlName="status" (change)="statusChanged()" class="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-accent sm:text-sm sm:leading-6">
            <option value="PENDING">Provisional</option>
            <option value="CONFIRMED" selected>Confirmed</option>
          </select>
          <div class="">
            <button type="submit" [disabled]="!appointmentForm.valid" class="rounded-md bg-accent px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-accent-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent">Save</button>
          </div>
        </div>
       
      </div>
    </form>
  </div>

  

  
</div>


            </div>
          </div>

          <div *ngIf="appointment  && appointment.customer" class="absolute top-0 left-0 w-full px-8 py-4 bg-red-700 text-white text-xl">
            <span *ngIf="appointment.customer" class="font-bold">Editing Appointment For:</span> {{ (appointment.customer.getFullName) ? appointment.customer.getFullName() : appointment.customer.firstName}}
            <button type="button" (click)="closeClicked()" (touchstart)="closeTouched($event)" class="close-btn absolute right-4 top-1/2 transform  -translate-y-1/2 rounded-md text-white hover:text-black hover:bg-white focus:outline-none focus:ring-2 focus:ring-accent-light focus:ring-offset-2">
              <span class="absolute -inset-2.5"></span>
              <span class="sr-only">Close panel</span>
              <svg class="h-6 w-6 " fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
